import { tracking } from './shared/modules/tracking/reducer';
import { user } from './shared/modules/user/reducer';
import { cookieDashboard } from './dealer/cookieDashboard/reducer';

export const cookieReducers = {
  tracking,
  user,
  cookieDashboard,
};
